"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./AudioSourceEvents"));

__export(require("./ConnectionEvents"));

__export(require("./ConnectionMessage"));

__export(require("./ConnectionOpenResponse"));

__export(require("./Error"));

__export(require("./Events"));

__export(require("./EventSource"));

__export(require("./Guid"));

__export(require("./IConnection"));

__export(require("./List"));

__export(require("./PlatformEvent"));

__export(require("./Promise"));

__export(require("./Queue"));

__export(require("./RawWebsocketMessage"));

__export(require("./RiffPcmEncoder"));

__export(require("./Stream"));

var TranslationStatus_1 = require("../common.speech/TranslationStatus");

exports.TranslationStatus = TranslationStatus_1.TranslationStatus;

__export(require("./ChunkedArrayBufferStream"));